import startup from "../assets/startup.jpg";
import gpt from "../assets/gpt.jpeg";
import enterprise from "../assets/enterprise.jpg";
import layerzero from "../assets/layerzero.jpg";
import ukraine from "../assets/bitcoin-ukraine.jpg";
import lebanon from "../assets/lebanon.png";
import AA from "../assets/AA.webp";
import consensus from "../assets/consensus.png";
import passivum from "../assets/passivum.jpg";
import skeptics from "../assets/skeptics.png";  
import web3soc from "../assets/web3soc.png";
import aiart from "../assets/aiart.png";

export const ArticleList = [
    {
        title: "Art in the Age of Digital Intelligence", 
        thumbnail: aiart,
        date: "August 6, 2025",
        hyperlink: "https://medium.com/@giozaarour/art-in-the-age-of-digital-intelligence-002735c7807d",
    },
    {
        title: "Web3 Social: Driving New Forms of Identity, Connection & Value Creation", 
        thumbnail: web3soc,
        date: "October 5, 2023",
        hyperlink: "https://giozaarour.medium.com/web3-social-driving-new-forms-of-identity-connection-value-creation-889babc9fe54",
    },
    {
        title: "On Crypto Skepticism and Misconceptions", 
        thumbnail: skeptics,
        date: "July 24, 2023",
        hyperlink: "https://giozaarour.medium.com/on-crypto-skepticism-and-misconceptions-fa6979566a2d",
    },
    {
        title: "Passivum -- Playing Around with Account Abstraction", 
        thumbnail: passivum,
        date: "May 24, 2023",
        hyperlink: "https://giozaarour.medium.com/passivum-playing-around-with-account-abstraction-a49bfd01983f",
    },
    {
        title: "The Fault-Tolerant Consensus Problem and Its Solutions in Blockchains and Distributed Systems", 
        thumbnail: consensus,
        date: "May 19, 2023",
        hyperlink: "https://giozaarour.medium.com/the-fault-tolerant-consensus-problem-and-its-solutions-in-blockchains-and-distributed-systems-7f883227ebc7",
    },
    {
        title: "Deep Dive into Account Abstraction and EIP-4337: Scaling Ethereum UX from Zero to One", 
        thumbnail: AA,
        date: "Mar 27, 2023",
        hyperlink: "https://giozaarour.medium.com/deep-dive-into-account-abstraction-and-eip-4337-scaling-ethereum-ux-from-0-to-1-c2e6da49d226",
    },
    {
        title: "Lebanon: A Broken Country — Macroeconomic Overview and Crisis Analysis", 
        thumbnail: lebanon,
        date: "Feb 18, 2023",
        hyperlink: "https://giozaarour.medium.com/lebanon-a-broken-country-macroeconomic-overview-and-crisis-analysis-ee82de4c9c22",
    },
    {
        title: "Lessons Learned Launching a Startup in College", 
        thumbnail: startup,
        date: "Dec 18, 2022",
        hyperlink: "https://giozaarour.medium.com/lessons-learned-launching-a-startup-in-college-aeee056ca79a",
    },
    {
        title: "OpenAI’s GPT-3: The Ethical Landscape of a Powerful Tool", 
        thumbnail: gpt,
        date: "Dec 6, 2022",
        hyperlink: "https://giozaarour.medium.com/openais-gpt-3-the-ethical-landscape-of-a-powerful-tool-9ff08c0c5dbb",
    },
    {
        title: "Blockchain but Not Currency: Distributed Ledger Technology Is Innovation for Enterprises", 
        thumbnail: enterprise,
        date: "Sep 25, 2022",
        hyperlink: "https://giozaarour.medium.com/blockchain-but-not-currency-distributed-ledger-technology-is-innovation-for-enterprises-3f0a44796a39",
    },
    // {
    //     title: "Layerzero: The Possible Future of Blockchain Interoperability", 
    //     thumbnail: layerzero,
    //     date: "May 6, 2022",
    //     hyperlink: "https://giozaarour.medium.com/layerzero-the-possible-future-of-blockchain-interoperability-7c7ed61ce433",
    // },
    {
        title: "How the Ukraine War Is a Test for Crypto — And Why Crypto Is Passing", 
        thumbnail: ukraine,
        date: "Apr 4, 2022",
        hyperlink: "https://giozaarour.medium.com/how-the-ukraine-war-is-a-test-for-crypto-and-why-crypto-is-passing-b8dde37285d1",
    },
];